export default __webpack_public_path__ + "static/media/danatoken-left-mobile-bg.2ab9ba9c.png";